import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { PerformanceTableSkeleton } from './components/PerformanceTableSkeleton/PerformanceTableSkeleton';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';

export const PerformanceDetailsEmpty: React.FC = () => {
  return (
    <PerformanceTableSkeleton>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </PerformanceTableSkeleton>
  );
};
